export default __webpack_public_path__ + "static/media/stride_ahead_logo.7a2d78b9.svg";